import { format } from 'date-fns'
import { fr } from 'date-fns/locale'

export function convertDateToFR(isoDate: string): string {
  const isoRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!isoRegex.test(isoDate)) {
    throw new Error('Format de date invalide. Attendu: YYYY-MM-DD');
  }
  const [annee, mois, jour] = isoDate.split('-');
  return `${jour}/${mois}/${annee}`;
}

export const formatDateToFR = (date: Date): string => {
  try {
    return format(date, 'dd MMMM yyyy', { locale: fr })
  } catch (error) {
    return date.toString()
  }
}

